import API from "../libs/api";

const WorkingDaysService = {
  getAll: async () => {
    return API.get("/api/superadmin/working-days/all");
  },

  getById: async (id) => {
    return API.get(`/api/superadmin/working-days/${id}`);
  },

  getBySchool: async (schoolId) => {
    return API.get(`/api/superadmin/working-days/school/${schoolId}`);
  },

  getByAcademicYear: async (yearId) => {
    return API.get(`/api/superadmin/working-days/academic-year/${yearId}`);
  },

  getBySchoolAndYear: async (schoolId, yearId) => {
    return API.get(`/api/superadmin/working-days/school/${schoolId}/year/${yearId}`);
  },

  add: async (payload) => {
    return API.post("/api/superadmin/working-days/add", payload);
  },

  update: async (id, payload) => {
    return API.put(`/api/superadmin/working-days/update/${id}`, payload);
  },

  delete: async (id) => {
    return API.delete(`/api/superadmin/working-days/delete/${id}`);
  },
};

export default WorkingDaysService;
